module.exports = __webpack_public_path__ + "img/20-a73af0.png";